// TcmCostEstimateDetailsMasterDetail.js
import { useEffect, useRef, useState } from 'react';
import DataGrid, {
    Column,
    Toolbar,
    Item as ToolbarItem,
    Lookup
} from 'devextreme-react/data-grid';
import InfoHeader from '../components/InfoHeader';

const TcmCostEstimateDetailsMasterDetail = ({
    estimate,       // the estimate row (with TCMCostEstimateDetails)
    editing,        // whether project is in edit mode
    priceBooks,     // lookup data
    onEstimateChange
}) => {
    const [details, setDetails] = useState(estimate.TCMCostEstimateDetails || []);
    const detailGridRef = useRef(null);

    // keep local details in sync when estimate changes
    useEffect(() => {
        setDetails(estimate.TCMCostEstimateDetails || []);
    }, [estimate]);

    // whenever details change locally, push up a new estimate object
    // useEffect(() => {
    //     onEstimateChange({
    //         ...estimate,
    //         TCMCostEstimateDetails: details
    //     });
    // }, [details]); // eslint-disable-line react-hooks/exhaustive-deps


    return (
        <DataGrid
            id="tcmCostEstimateDetailsDataGrid"
            dataSource={details}
            keyExpr="Id"
            showBorders={true}
            columnAutoWidth={true}
            ref={detailGridRef}
        >

            <Column dataField="ItemDescription" caption="Item Description" dataType="string" />
            <Column
                dataField="UnitPrice"
                caption="Unit Price"
                dataType="number"
                format={{ type: 'currency', precision: 2 }}
            />
            <Column dataField="PriceBookId" caption="Unit of Issue">
                <Lookup
                    dataSource={priceBooks}
                    displayExpr="UnitOfIssue"
                    valueExpr="Id"
                />
            </Column>
            <Column dataField="Quantity" caption="Quantity" dataType="number" />
            <Column
                dataField="LaborPrice"
                caption="Labor Rate"
                dataType="number"
                format={{ type: 'currency', precision: 2 }}
            />
            <Column dataField="LaborHours" caption="Labor Hours" dataType="number" />
            <Column dataField="Comments" caption="Comments" />

            <Column
                caption="Unit Cost"
                dataType="number"
                format={{ type: 'currency', precision: 2 }}
                allowEditing={false}
                headerCellRender={() =>
                    <InfoHeader
                        label="Unit Cost"
                        tooltip="Unit Price * Quantity"
                    />
                }
                calculateCellValue={rowData => {
                    const unitPrice = Number(rowData.UnitPrice) || 0;
                    const quantity = Number(rowData.Quantity) || 0;
                    const value = unitPrice * quantity;
                    return Number(value.toFixed(2));
                }}
            />

            <Column
                caption="Labor Cost"
                dataType="number"
                format={{ type: 'currency', precision: 2 }}
                allowEditing={false}
                headerCellRender={() =>
                    <InfoHeader
                        label="Labor Cost"
                        tooltip="Labor Rate * Labor Hours"
                    />
                }
                calculateCellValue={rowData => {
                    const laborPrice = Number(rowData.LaborPrice) || 0;
                    const laborHours = Number(rowData.LaborHours) || 0;
                    const value = laborPrice * laborHours;
                    return Number(value.toFixed(2));
                }}
            />

            <Column
                caption="Total Cost"
                dataType="number"
                format={{ type: 'currency', precision: 2 }}
                allowEditing={false}
                headerCellRender={() =>
                    <InfoHeader
                        label="Total Cost"
                        tooltip="Labor Cost + Unit Cost"
                    />
                }
                calculateCellValue={rowData => {
                    const laborPrice = Number(rowData.LaborPrice) || 0;
                    const laborHours = Number(rowData.LaborHours) || 0;
                    const unitPrice = Number(rowData.UnitPrice) || 0;
                    const quantity = Number(rowData.Quantity) || 0;

                    const value =  (unitPrice * quantity) + (laborPrice * laborHours);
                    return Number(value.toFixed(2));
                }}
            />
        </DataGrid>
    );
};

export default TcmCostEstimateDetailsMasterDetail;